import React, { useState, useCallback, useEffect } from 'react';
import CommunicationPipelineProgressStep from './CommunicationPipelineProgressStep';
import { statusSteps, statusProgress, statusSign } from './constants/options';

export default function CommunicationPipelineProgressTimeLine(props) {
  const { report, pageStep } = props;
  const [statusProgressSteps, setStatusProgressSteps] = useState([]);

  useEffect(() => {
    if (pageStep === 'sign') {
      setStatusProgressSteps(
        statusSign.filter((sp) =>
          ['denied', 'redirected', 'informationRequest', 'approved'].includes(
            sp.value
          )
        )
      );
    } else {
      setStatusProgressSteps(
        statusProgress.filter((sp) =>
          ['unInitialized', 'inProgress', 'completed'].includes(sp.value)
        )
      );
    }
  }, []);

  const getProgressInfo = useCallback(
    (progress) => {
      let isFaint = true;
      let isReadOnly = true;

      const pageStepIndex = statusSteps.findIndex(
        (ss) => ss.value === pageStep
      );
      const currentStepIndex = statusSteps.findIndex(
        (ss) => ss.value === report?.status.step
      );

      switch (progress) {
        case 'denied':
        case 'redirected':
        case 'approved':
          if (
            pageStepIndex === currentStepIndex &&
            report?.status.progress === progress
          ) {
            isFaint = false;
          }
          if (
            (pageStepIndex - 1 === currentStepIndex &&
              report?.status.progress === 'completed') ||
            (pageStepIndex === currentStepIndex &&
              report?.status.progress === 'informationRequest')
          ) {
            isReadOnly = false;
          }
          break;
        case 'informationRequest':
          if (
            pageStepIndex === currentStepIndex &&
            report?.status.progress === progress
          ) {
            isFaint = false;
          }
          if (
            pageStepIndex - 1 === currentStepIndex &&
            report?.status.progress === 'completed'
          ) {
            isReadOnly = false;
          }
          break;
        case 'inProgress':
          if (
            (pageStepIndex === currentStepIndex &&
              ['inProgress', 'completed'].includes(report?.status.progress)) ||
            pageStepIndex <= currentStepIndex
          ) {
            isFaint = false;
          }
          if (
            (pageStepIndex - 1 === currentStepIndex &&
              report?.status.progress === 'completed') ||
            (pageStepIndex - 1 === currentStepIndex &&
              report?.status.progress === 'approved')
          ) {
            isReadOnly = false;
          }
          break;
        case 'completed':
          if (
            (pageStepIndex === currentStepIndex &&
              report?.status.progress === 'completed') ||
            currentStepIndex > pageStepIndex
          ) {
            isFaint = false;
          }
          if (
            (pageStepIndex === currentStepIndex &&
              report?.status.progress === 'inProgress') ||
            (pageStepIndex - 1 === currentStepIndex &&
              report?.status.progress === 'completed' &&
              ['subjectToAppeal', 'end'].includes(pageStep))
          ) {
            isReadOnly = false;
          }
          break;
        default:
          // unInitialized
          isFaint = false;
          isReadOnly = true;
      }

      return { isFaint, isReadOnly };
    },
    [report, pageStep, statusSteps]
  );

  return (
    <div className="d-flex justify-content-center flex-wrap mt-5">
      {statusProgressSteps
        .filter(
          (sp) =>
            !['subjectToAppeal', 'end'].includes(pageStep) ||
            (['subjectToAppeal', 'end'].includes(pageStep) &&
              sp?.value !== 'inProgress')
        )
        .map((sp) => (
          <React.Fragment key={sp?.value}>
            <CommunicationPipelineProgressStep
              report={report}
              pageStep={pageStep}
              statusProgress={sp}
              reportStatus={report?.status}
              progressInfo={getProgressInfo(sp?.value)}
            />
          </React.Fragment>
        ))}
    </div>
  );
}
